import React from 'react'
import { DateField, DateFieldProps, Labeled } from 'react-admin'

type Props = Omit<DateFieldProps, 'label'> & {
  label: string
}

const LabeledDateField: React.FC<Props> = ({ label, ...rest }) => {
  return (
    <Labeled label={label} sx={{ marginBottom: '16px' }}>
      <DateField {...rest} />
    </Labeled>
  )
}

export default LabeledDateField
